import { defineStore } from 'pinia';
import { IMenuItem, MenuState } from './type.d';
import { RESOURCE_TYPE_ENUM } from '@/api/menu/type';
import { getUserResource } from '@/api/menu';
import { uniq } from 'lodash-es';

// 首页路由配置
const BASE_ROUTE: IMenuItem[] = [
  {
    frontEndUrl: 'Dashboard',
    resourceName: '首页',
    resourceType: RESOURCE_TYPE_ENUM.MENU,
    icon: 'document',
  },
];
export const useMenuStore = defineStore({
  id: 'menu',
  state: (): MenuState => ({
    menus: [],
    isGetMenu: false,
    authMenuList: [],
    authButtonList: [],
  }),
  getters: {
    menuList() {
      return this.menus;
    },
  },
  actions: {
    async getMenus() {
      try {
        if (this.isGetMenu) return;
        const { data = [] } = await getUserResource();
        this.menus = [...BASE_ROUTE, ...data];
        const authMenuList: string[] = ['Dashboard'];
        const authButtonList: string[] = [];
        const deep = (menuTree: IMenuItem[]) => {
          menuTree.forEach((it) => {
            if (it.resourceType === RESOURCE_TYPE_ENUM.MENU && it.frontEndUrl) {
              authMenuList.push(it.frontEndUrl);
            }
            if (it.children?.length && it.resourceType !== RESOURCE_TYPE_ENUM.BUTTON) {
              deep(it.children);
            } else if (it.resourceType === RESOURCE_TYPE_ENUM.BUTTON) {
              if (it.frontEndUrl) {
                authMenuList.push(...it.frontEndUrl.split(','));
              }
              if (it.resourceCode) {
                authButtonList.push(it.resourceCode);
              }
            }
          });
        };
        deep(data);
        this.authMenuList = uniq(authMenuList);
        this.authButtonList = uniq(authButtonList);
        this.isGetMenu = true;
      } catch (e) {
        console.log(e);
      }
    },
    clearMenus() {
      this.menus = [];
      this.authMenuList = [];
      this.authButtonList = [];
      this.isGetMenu = false;
    },
  },
});
